import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PaymentService } from '../../shared/api/payments/payment.service';
import { startWith, switchMap } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-payment-result',
  templateUrl: './payment-result.component.html',
  styleUrls: ['./payment-result.component.scss']
})
export class PaymentResultComponent implements OnInit {

  hash: string = '';
  paid: boolean = false;
  plan: string = '';

  private polling?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private paymentService: PaymentService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.hash = this.route.snapshot.queryParamMap.get('hash') ?? '';
    if (!this.hash) {
      return;
    }

    this.polling = interval(10000)
      .pipe(
        startWith(0), // ejecuta inmediatamente la primera vez
        switchMap(() => this.paymentService.getStatus(this.hash))
      )
      .subscribe({
        next: (response) => {
          this.paid = response.paid;
          this.plan = response.plan;
          this.cdr.detectChanges();
          if (this.paid) {
            this.polling?.unsubscribe();
          }
        },
        error: (err) => {
          console.error(err);
        }
      });
  }

  ngOnDestroy(): void {
    this.polling?.unsubscribe();
  }

  closePage(): void {
    window.close();
    // window.location.href = 'https://mediget.org';
  }
}